// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentPatientSearchResultModel {
    static getAttributeTypeMap() {
        return EnrollmentPatientSearchResultModel.attributeTypeMap;
    }
}
EnrollmentPatientSearchResultModel.discriminator = undefined;
EnrollmentPatientSearchResultModel.additionalProperties = false;
EnrollmentPatientSearchResultModel.attributeTypeMap = [
    {
        "name": "results",
        "baseName": "results",
        "type": "Array<EnrollmentPatientSearchRecordModel>"
    },
];
//# sourceMappingURL=enrollmentPatientSearchResultModel.js.map